module.exports = __webpack_public_path__ + "media/images/cliparts/Income up - PMT_M35_08-40568fe43ee0e10f6ec55076a30017e9.svg";